import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            change: {
                'select': 'changeForm'
            }
        }
    }

    init() {

    }

    changeForm(e) {
        let value = e.curTarget.value;
        let url = value

        this.call('goTo', { url: value, transition: 'form' }, 'Load')
    }
}
